<router-link
  :to="routeTarget"
  class="public-search-result-card public-hover-card public-hover-card--scroll"
  :class="[cardClass, { 'public-search-result-card--tournament': isTournamentResult }]"
>
  <div v-if="isTournamentResult" class="public-search-result-card__tournament-top">
    <span
      class="public-search-result-card__type"
      :class="`public-search-result-card__type--${item.type}`"
    >
      {{ resolvedTypeLabel }}
    </span>

    <div class="public-search-tournament-card__badges">
      <span
        class="public-tournament-card__system public-tournament-system-badge badge"
        :class="tournamentSystemClass"
      >
        {{ tournamentSystemLabel }}
      </span>
      <span
        v-if="tournamentDateBadge"
        class="public-date-badge"
        :class="tournamentDateBadgeClass"
      >
        {{ tournamentDateBadge }}
      </span>
      <span class="public-status-badge" :class="tournamentStatus.className">
        <i :class="tournamentStatus.icon"></i>
        {{ tournamentStatus.label }}
      </span>
    </div>
  </div>

  <span
    v-else
    class="public-search-result-card__type"
    :class="`public-search-result-card__type--${item.type}`"
  >
    {{ resolvedTypeLabel }}
  </span>

  <h3>{{ item.title }}</h3>
  <p>{{ isTournamentResult ? tournamentSubtitle : resolvedMeta }}<template v-if="isTournamentResult && tournament.place?.name"> · <span class="d-inline-flex align-items-center gap-1 text-nowrap"><i class="bi bi-geo-alt" aria-hidden="true"></i>{{ tournament.place.name }}</span></template></p>

  <div v-if="isTournamentResult" class="public-search-result-card__tournament-meta">
    <span>
      <IconChessVariant
        :variant="tournament.chessVariant"
        size="13px"
        color="var(--app-accent-gold)"
      />
      {{ tournamentChessVariantLabel }}
    </span>
    <span>
      <component
        :is="tournamentControlIcon"
        v-if="tournamentControlIcon"
        size="13px"
        color="var(--app-accent-gold)"
      />
      <i v-else class="bi bi-clock"></i>
      {{ tournamentControlLabel }}
    </span>
    <span>
      <i :class="tournamentRatedIcon" :style="{ color: tournamentRatedIconColor }"></i>
      {{ tournamentRatedLabel }}
    </span>
    <span>
      <i :class="tournamentFormatIcon" :style="{ color: tournamentFormatIconColor }"></i>
      {{ tournamentFormatLabel }}
      <template v-if="tournamentTeamMode">
        <i :class="tournamentTeamMode.icon"></i>
        {{ tournamentTeamMode.label }}
      </template>
    </span>
  </div>

  <div v-else class="public-search-result-card__footer">
    <span>
      <i v-if="item.icon" :class="item.icon"></i>
      {{ resolvedDetail }}
    </span>
    <b>{{ resolvedAction }}</b>
  </div>
</router-link>
